import React from 'react';
import { NavLink } from 'react-router-dom';

import './NavLinks.css';

const NavLinks = props => {
  return (
    <ul className="nav-links">
      <li>
        <NavLink to="/datasets" >DATASETS</NavLink>
      </li> 
      <li>
          <NavLink to="/classes" >CLASSES</NavLink>
      </li>
        <li>
          <NavLink to="/recommender">RECOMMENDER</NavLink>
        </li>
    </ul>
  );
};

export default NavLinks;
